import * as React from "react"
import { RouteComponentProps } from "@gatsbyjs/reach-router"
import { RawLogs, RawLogItem } from "gatsby-interface"
import { Loading } from "gatsby-ui/src/components"
import {
  useLogsForMerlinSourceEventQuery,
  MerlinRawLogsCreatedDocument,
} from "./queries.generated"
import { ErrorAlert } from "../shared/error-alert"

interface SourceEventRawLogsProps extends RouteComponentProps {
  organizationId: string
  siteId: string
  sourceEventId: string
}

export function SourceEventRawLogs({
  siteId,
  sourceEventId,
}: SourceEventRawLogsProps) {
  const [offset, setOffset] = React.useState(0)
  const { data, loading, error, subscribeToMore } =
    useLogsForMerlinSourceEventQuery({
      variables: {
        sourceEventId,
        offset,
      },
    })

  React.useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: MerlinRawLogsCreatedDocument,
      variables: {
        sourceEventId,
      },
      updateQuery: (prev, { subscriptionData }) => {
        if (!subscriptionData?.data) return prev
        const next = subscriptionData.data.merlinRawLogsCreated
        return {
          ...prev,
          logsForMerlinSourceEvent: [...prev.logsForMerlinSourceEvent, next],
        }
      },
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <>
      {loading && <Loading message="Loading data layer activities..." />}

      {error && <ErrorAlert>{error.message}</ErrorAlert>}

      {data && (
        <div>
          <RawLogs
            logItems={data.logsForMerlinSourceEvent as RawLogItem[]}
            aria-label="Source Event Logs"
          />
        </div>
      )}
    </>
  )
}
